import {BrowserRouter, Routes, Route} from "react-router-dom";
import './style/Layout.css';
import Header from './layout/Header';
import Footer from './layout/Footer';
import Main from './layout/Main';

function App() {
  return (
    <>
      <BrowserRouter>
        <Header />

        <Routes>
          <Route path="/portfolio" element={<Main />}/>
        </Routes>
        
        <Footer />
      </BrowserRouter>

      
    </>
  );
}

export default App;
